// TODO MINICART MESSAGE ON PRODUCT ADDED

// document.addEventListener("DOMContentLoaded", function () {
//   const minicartMessage = document.getElementById('miniCartMessage')
//   console.log('minicartMessage:', minicartMessage)
//   if (!!minicartMessage){
//     console.log('exists')
    // document.addEventListener('product:added', function(event) {
    //   console.log('added')
    //   minicartMessage.classList.add("active");
    // });
//   }
// });





// document.addEventListener('cart:rerendered', function(event) {
//   console.log('event:', event)
// });